import { useGetAllActionPlan } from "src/api/client-api/ActionPlan/ActionPlan/useGetAllActionPlan";
import { useGetOneActionPlan } from "src/api/client-api/ActionPlan/ActionPlan/useGetOneActionPlan";
import { OlapScoresQuery } from "../OlapScores/useOlapScoresParams";

type Options = {
    params?: AxiosParams;
    scoresQuery?: OlapScoresQuery;
};

export const useGetOneAction = (options: Options) => {
    const { params, scoresQuery } = options;
    const {
        data: _actionPlan,
        isLoading,
        isFetched: areAllActionsPlansFetched,
        isRefetching: areAllRefetching,
    } = useGetAllActionPlan({
        queryParam: params,
    });

    const selectedActionPlanID = _actionPlan?.[0]?.id;

    const {
        data: actionPlan,
        isFetched: isSingleActionPlanFetched,
        isRefetching: isSingleRefetching,
    } = useGetOneActionPlan({
        actionPlanId: selectedActionPlanID,
        scoresQuery,
    });

    const isFetched =
        areAllActionsPlansFetched ?
            (_actionPlan ?? []).length > 0 ?
                isSingleActionPlanFetched && areAllActionsPlansFetched
            :   areAllActionsPlansFetched
        :   areAllActionsPlansFetched;

    const isRefetching =
        areAllRefetching ?
            (_actionPlan ?? []).length > 0 ?
                isSingleRefetching && areAllRefetching
            :   areAllRefetching
        :   areAllRefetching;

    return {
        actionPlan,
        isLoading,
        isFetched,
        isRefetching,
    };
};
